module.exports = __webpack_public_path__ + "img/logo.5093cd5d.png";